/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Cancel_After_ModelInputs */



/**
* | output |
* | --- |
* | "oneAI Standard only, with a daily allowance" |
*
* @param {Sub_Cancel_After_ModelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_cancel_after_model = /** @type {((inputs?: Sub_Cancel_After_ModelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Cancel_After_ModelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur oneAI Standard, mit einem Tagesguthaben")
	return /** @type {LocalizedString} */ ("oneAI Standard only, with a daily allowance")
});